<div class="container" [class.selected]="isSelected()">
  <div class="content">
    <rt-icon [name]="iconName()" size="medium" [hasAutoHeight]="true" />
    <div class="text-container">
      <span class="label">{{ label() }}</span>
      <span>{{ description() }}</span>
    </div>
  </div>
  <rt-radio [checked]="isSelected()" />
</div>
